// Module
var code = "<react-component name=\"GymMetricsReport\"></react-component>\n";
// Exports
module.exports = code;